import type { RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
  {
    path: '/email-templates',
    name: 'email-templates',
    meta: { title: 'Email Templates' },
    component: () => import('@/views/email-templates/EmailTemplateListView.vue')
  },
  {
    path: '/email-templates/create',
    name: 'email-template-create',
    meta: { title: 'Create footer template' },
    component: () => import('@/views/email-templates/EmailTemplateCreateView.vue')
  },
  {
    path: '/email-templates/:id',
    name: 'email-template-edit',
    props: true,
    meta: { title: 'Edit email template' },
    component: () => import('@/views/email-templates/EmailTemplateEditView.vue')
  }
]

export default routes
